export const ARMORS = [
  { name: 'ぬののふく', value: 2 },
  { name: 'かわのよろい', value: 6 },
  { name: 'くさりかたびら', value: 12 },
  { name: 'はがねのよろい', value: 25 },
  { name: 'みかわしのふく', value: 35 },
  { name: 'まほうのよろい', value: 35 },
  { name: 'ガイアのよろい', value: 47 },
  { name: 'ミンクのコート', value: 60 },
  { name: 'みずのはごろも', value: 65 },
  { name: 'ロトのよろい', value: 75 },
  { name: 'あくまのよろい', value: 87 }
]
